import React, { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { LawFirmInfos } from '../lawFirm.types';
import { CommonApp } from '../../common/components/common-app/CommonApp';
import { ReportTimeSystemEntity } from '../../report-time-system/ReportTimeSystemEntity';
import { LawFirmMain } from './LawFirmMain';

type Props = {
  lawFirmInfos: LawFirmInfos;
  readKey: string;
};

export const LawFirmApp: FC<Props> = ({ lawFirmInfos, readKey }) => (
  <CommonApp>
    <ReportTimeSystemEntity entityType="lawFirm" readKey={readKey}>
      <BrowserRouter>
        <LawFirmMain lawFirmInfos={lawFirmInfos} />
      </BrowserRouter>
    </ReportTimeSystemEntity>
  </CommonApp>
);
